export function setInventoryGrid(type: string) {
  localStorage.setItem('inventory_grid', type);
}
